import { Alert } from "@mui/material";
import TimeIcon from "@mui/icons-material/AccessTime";
import useCountdown from "../../hooks/useCountdown";

type Props = {
    time: number;
    onTimeUp: () => void;
    prefix?: string;
    suffix?: string;
};

const CartExpiryBanner = ({
    time,
    onTimeUp,
    prefix = "You have",
    suffix = "to checkout.",
}: Props) => {
    const timeRemaining = useCountdown(time, onTimeUp);

    return (
        <Alert severity="warning" icon={<TimeIcon />}>
            {prefix} {timeRemaining} {suffix}
        </Alert>
    );
};

export default CartExpiryBanner;
